export enum DriverWorkYearsPeriods {
  All = -2,
  None = -1,
  Below5 = 0,
  Below1 = 1,
  Above2Below10 = 2,
  Above5Below10 = 5,
  Above10Below15 = 10,
  Above11Below20 = 11,
  Above15Below20 = 15,
  Above20 = 20,
  Above21 = 21,
  Below4 = 22,
  Above4Below8 = 23,
  Above8Below12 = 24,
  Above12 = 25,
}
